import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { ICompanyMastDropdown } from "../../models/IDropdown";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";

interface IProps {
    open: boolean,
    singleData: any,
    hideDialog: () => void,
    toast: any
}

export const CompanyMapping = (props: IProps) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [company, setCompany] = useState(null as number | null);
    const [disableOnSubmit, setDisableOnSubmit] = useState<boolean>(false);
    const onHide = () => {
        props.hideDialog();
    };

    const selectCompany = (e: any) => {
        let data: any = e;
        setCompany(data);
    };

    const loadCompanies = async () => {
        const response = await Fetch("Allocate_Team_Mast/company", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            setCompanies(prev => prev = data);
            if (props.open && props.singleData?.team_ID) {
                getTeamMapping(props.singleData.team_ID);
            }
        }
    };

    const onSubmit = async () => {
        setDisableOnSubmit(true);
        let newData = {
            Company_ID: company,
            Team_ID: props.singleData.team_ID
        };
        const response = await Fetch(`Allocate_Team_Mast/addTeamMapping`, "POST", newData, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
            setDisableOnSubmit(false);
        } else {
            setDisableOnSubmit(false);
        }
    }

    const getTeamMapping = async (team_ID: number) => {
        const response = await Fetch(`Allocate_Team_Mast/getTeamMapping`, "GET", null, `teamID=${team_ID}`, props.toast);
        if (response) {
            const data: ICompanyMastDropdown = await response.json();
            selectCompany(data.company_ID);
        }
    }

    useEffect(() => {
        loadCompanies();
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '25vw' }} header="Add/Edit Team Company Mapping" modal className="p-fluid" onHide={onHide}>
            <div className="flex align-content-center mt-6 gap-3">
                <div>
                    <label>Company</label>
                    <Dropdown value={company} onChange={(e: any) => selectCompany(e.value)} options={companies} optionValue="company_ID" optionLabel="company_Name" placeholder="Select a Company" className="w-full md:w-14rem" showClear />
                </div>
                <div className="flex align-content-center mt-3 gap-3">
                    <Button disabled={disableOnSubmit} className="h-2.3rem w-6rem" onClick={onSubmit}>SUBMIT</Button>
                </div>
            </div>
        </Dialog>
    );
}